import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
    imports: [
        TranslateModule,
        RouterModule
    ],
    selector: 'footer-component',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
    public lang: string | null = null;

    constructor(
        private readonly translateService: TranslateService,
    ) {
        this.lang = this.translateService.currentLang;
        this.translateService.onLangChange.subscribe((event) => {
            this.lang = event.lang;
        })

    }
}